<div class="flex flex-col gap-4">
  <div class="flex shrink-0 flex-wrap items-center justify-between gap-2">
    <div class="flex flex-col gap-1">
      <h2 class="text-lg font-semibold text-surface-900 dark:text-surface-0 m-0">
        Review Tab Policy
      </h2>
      @if (updatedAtLabel()) {
        <p
          class="m-0 text-xs text-surface-600 dark:text-surface-400"
          [title]="updatedAt() ?? ''"
        >
          Last updated {{ updatedAtLabel() }}
          @if (updatedBy()) {
            by {{ updatedBy() }}
          }
        </p>
      }
    </div>
    <div class="flex flex-wrap items-center gap-2">
      <p-select
        [options]="dispositionFilterOptions"
        [ngModel]="dispositionFilter()"
        (ngModelChange)="onDispositionFilterChange($event)"
        optionLabel="label"
        optionValue="value"
        placeholder="Filter by disposition"
        styleClass="min-w-[10rem]"
        ariaLabel="Filter policy rows by disposition"
      />
      <p-button
        label="Refresh"
        icon="pi pi-refresh"
        [outlined]="true"
        [disabled]="loading()"
        (onClick)="reload()"
      />
    </div>
  </div>

  <div class="rounded-lg border border-surface-200 dark:border-surface-700">
    <p-table
      [value]="visibleRows()"
      dataKey="actionType"
      [loading]="loading() && rows().length === 0"
      [showLoader]="true"
      [paginator]="true"
      [rows]="tableRowsPerPage"
      [alwaysShowPaginator]="false"
      sortMode="single"
      sortField="actionType"
      [sortOrder]="1"
      [stripedRows]="true"
      [showGridlines]="true"
      styleClass="border-0 text-sm shadow-none"
      [tableStyle]="{ 'min-width': '50rem' }"
    >
      <ng-template pTemplate="header">
        <tr>
          <th pSortableColumn="actionType" scope="col" class="whitespace-nowrap">
            <span class="inline-flex items-center gap-1">
              Action type
              <p-sortIcon field="actionType" />
            </span>
          </th>
          <th pSortableColumn="disposition" scope="col" class="whitespace-nowrap">
            <span class="inline-flex items-center gap-1">
              Disposition
              <p-sortIcon field="disposition" />
            </span>
          </th>
          <th scope="col">Description</th>
          <th scope="col" class="w-32 text-end">Actions</th>
        </tr>
      </ng-template>

      <ng-template pTemplate="body" let-row>
        <tr>
          <td class="font-mono text-xs">{{ row.actionType }}</td>
          <td class="font-mono text-xs">{{ row.disposition }}</td>
          <td class="text-surface-600 dark:text-surface-400 max-w-md">
            {{ descriptionPreview(row.description) }}
          </td>
          <td class="text-end">
            <div class="flex flex-wrap justify-end gap-1">
              <p-button
                icon="pi pi-pencil"
                [text]="true"
                rounded
                (onClick)="openEdit(row)"
                [attr.aria-label]="'Edit ' + row.actionType"
              />
            </div>
          </td>
        </tr>
      </ng-template>

      <ng-template pTemplate="emptymessage">
        <tr>
          <td colspan="4" class="px-3 py-6 text-center text-surface-600 dark:text-surface-400">
            No rows returned.
          </td>
        </tr>
      </ng-template>
    </p-table>
  </div>

  <p-dialog
    header="Edit policy row"
    [modal]="true"
    [style]="{ width: 'min(40rem, 95vw)' }"
    [visible]="dialogOpen()"
    (visibleChange)="dialogOpen.set($event)"
    [closable]="true"
  >
    <form class="flex flex-col gap-3" [formGroup]="form" (ngSubmit)="save()">
      <div class="flex flex-col gap-1">
        <label class="text-sm font-medium" for="rpa-action-type">Action type</label>
        <input
          id="rpa-action-type"
          class="w-full rounded-md border border-surface-300 bg-surface-100 px-3 py-2 font-mono text-sm"
          [value]="form.controls.actionType.value"
          readonly
        />
      </div>
      <div class="flex flex-col gap-1">
        <label class="text-sm font-medium" for="rpa-disposition">Disposition</label>
        <p-select
          inputId="rpa-disposition"
          formControlName="disposition"
          [options]="dispositionOptionsFor(form.controls.actionType.value)"
          optionLabel="label"
          optionValue="value"
          styleClass="w-full"
          ariaLabel="Disposition for this action type"
        />
      </div>
      <div class="flex flex-col gap-1">
        <label class="text-sm font-medium" for="rpa-description">Description</label>
        <textarea
          pTextarea
          id="rpa-description"
          class="w-full"
          rows="4"
          formControlName="description"
        ></textarea>
      </div>
      <div class="flex justify-end gap-2 pt-2">
        <p-button type="button" label="Cancel" [outlined]="true" (onClick)="closeDialog()" />
        <p-button type="submit" label="Save" [loading]="saving()" [disabled]="saving()" />
      </div>
    </form>
  </p-dialog>
</div>
